// import HTML from "../index.html";
import "./style.scss";
import "./migration.scss";

import Sticky from "sticky-js";
import smoothscroll from "smoothscroll-polyfill";

import clickMore from "./scripts/show-more.js";
import toursCarousel from "./scripts/tours-carousel.js";
import mainCarousel from "./scripts/main-carousel.js";
import tombstonesCarousel from "./scripts/tombstones-carousel.js";

let stickyMobile = new Sticky(".navigation-in-page", {
  marginTop: 106
});
let stickyDesktop = new Sticky(".navigation-secondary", {
  marginTop: 106
});
smoothscroll.polyfill();

clickMore();
toursCarousel();
mainCarousel();
// Initialize tombstonesCarousel() for each instance.
document.querySelectorAll('.slider-with-external-buttons')
        .forEach(tombstonesCarousel);


/********************************* Modal *********************************/
import MicroModal from 'micromodal';  // es6 module
import modalStart from "./scripts/modal";
modalStart();

/********************************* Ajax functions *********************************/
// import {getAjax, postAjax} from "./scripts/ajax-functions";
// getAjax('http://foo.bar/?p1=1&p2=Hello+World', function(data){ console.log(data); });
// postAjax('http://foo.bar/', 'p1=1&p2=Hello+World', function(data){ console.log(data); });

/********************************* Secondary Navigation *********************************/
import secondaryNavigation from "./scripts/secondary-navigation";
secondaryNavigation();

/********************************* Lazy Load Trustpilot boxes *********************************/
import lazyloadTrustpilot from "./scripts/lazyload-trustpilot";
lazyloadTrustpilot ()

/********************************* Header SearchBar ********************************/

import headerSearch from "./scripts/header-search";
headerSearch();
/********************************* Header Submenu *********************************/

import headerSubmenu from "./scripts/header-submenu";
headerSubmenu();

/********************************* Lazy Loading Images *********************************/

import lazyloadImages from "./scripts/lazyload-images";
lazyloadImages ()

/********************************* Images on hover *********************************/

import swapImages from "./scripts/swap-images";
swapImages ()

/********************************* Images on hover *********************************/

import contactus from "./scripts/contact-us";
contactus ()

/********************************* scroll more *********************************/

import scrollmore from "./scripts/scrollmore";
scrollmore ()

/********************************* Collapsable Items *********************************/

import collapsable from "./scripts/collapsable";
collapsable ()

/********************************* Itineraries Page ********************************/

import itineraries from "./scripts/itineraries";
itineraries ()

/********************************* All Lodges Page ********************************/

import allLodges from "./scripts/all-lodges";
allLodges ()

/********************************* Sticky Header *********************************/

// function onScroll() {
//   // $$header.classList.contains('sticky');
//   if (window.pageYOffset > 15) {
//     $$header.classList.add('sticky');
//   } else {
//     $$header.classList.remove('sticky');
//   }
// }
// var $$header = document.querySelector("header");
// window.addEventListener('scroll', throttle(onScroll, 25));